var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"child-menu"},[_c('li',{staticClass:"childMenuTitle"},[_vm._v("Also in this section:")]),_vm._l((_vm.childMenuItems),function(menuItem,index){return _c('li',{key:index,staticClass:"childMenuItem"},[_c('a',{staticClass:"childMenuLink",attrs:{"href":menuItem.MenuItemRelativeUrl}},[_vm._v(_vm._s(menuItem.MenuItemText))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }